const getImageUrl = (url) => url && !url.includes('placeholder') ? url : '/images/product-placeholder.jpg';
var image = {};

export { image as default, getImageUrl };
//# sourceMappingURL=image.js.map
